export default __webpack_public_path__ + "5db52065b996cc5c867f65ece2bbf7c2.webp";